import WorkSpaceLocation from './WorkSpaceLocation';
export default WorkSpaceLocation;
